import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/lms-profiles.action'
import updateLmsProfile from 'api/lms-profiles/Edit'
import { ILmsProfileModel } from 'models/lmsProfile.model'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { errorMessage } from 'helpers/validators.helper'

async function updateProfile(data: ILmsProfileModel) {
  return await updateLmsProfile(data)
}

function* lmsProfilesEditProfileEffectSaga(action: any) {
  try {
    const { data } = yield call(updateProfile, action.payload)
    yield put(fromActions.Actions.lmsProfilesEditProfileSuccess(data))
    yield put(fromActions.Actions.lmsProfileListReload())
  } catch (error) {
    ErrorToast(I18n.t(`administration.toastMessages.${errorMessage(error, 'profileEditError')}`))
    console.log('error: ', error)
  }
}

export function* lmsProfilesEditProfileWatcherSaga() {
  yield takeLatest(fromActions.LMS_PROFILES_EDIT_PROFILE, lmsProfilesEditProfileEffectSaga)
}
